import './MarqueeSection.css'

const items = ['React','Node.js','TypeScript','Next.js','PostgreSQL','AWS','Flutter','Python','Tailwind','Docker','GraphQL','Supabase','Kotlin','Swift','Redis']

export default function MarqueeSection() {
  return (
    <div className="marquee-section">
      <div className="marquee-track">
        {[...items, ...items].map((item, i) => (
          <span className="marquee-item" key={i}>{item} <span className="marquee-dot" /></span>
        ))}
      </div>
    </div>
  )
}
